import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['currentUser', 'otherUser'];

  static values = { userId: String, broadcast: Boolean };

  connect() {
    const target = document.getElementById('customer_chat_messages');
    target.classList.remove('hidden');

    const { currentUserId } = target.dataset;
    if (this.userIdValue === currentUserId) {
      this.otherUserTarget.classList.add('hidden');
    } else {
      this.currentUserTarget.classList.add('hidden');
    }

    target.scrollIntoView(false);

    this.readContactByBroadCast(currentUserId);
  }

  readContactByBroadCast(currentUserId) {
    if (this.broadcastValue && this.userIdValue !== currentUserId) {
      fetch(`${this.element.dataset.readContactUrl}`, {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': document.querySelector('[name=csrf-token]').content,
        },
      });
    }
  }
}
